import { useSyncExternalStore } from 'react';
import { useNavigate } from 'react-router-dom';

import SessionExpiredPopup from 'common/SessionExpiredPopup';
import {
  getSessionExpiredOpen,
  resetSessionExpired,
  subscribeSessionExpired,
} from 'utils/sessionExpiredStore';

function useSessionExpiredOpen() {
  return useSyncExternalStore(
    subscribeSessionExpired,
    getSessionExpiredOpen,
    getSessionExpiredOpen
  );
}

const SessionExpiredHandler = () => {
  const open = useSessionExpiredOpen();
  const navigate = useNavigate();

  const handleLoginAgain = () => {
    localStorage.removeItem('userData');
    resetSessionExpired();
    navigate('/login');
  };

  return (
    <SessionExpiredPopup open={open} onLoginAgain={handleLoginAgain} />
  );
};

export default SessionExpiredHandler;
